/**
 * DEPRECATED: Please consult with the FE Performance team before using this file.
 */
import { store } from 'lib/store';

export default store;
